(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nkc-organza-selector"] && !Shopify.designMode) return;
  try {
    class NkcOrganzaSelector extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onFilterClick);
      this.applyStyle(this.dataset.currentStyle || 'ALL');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onFilterClick);
    }

    onFilterClick = (event) => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-organza-style]');
      if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
      this.applyStyle(button.dataset.organzaStyle || 'ALL');
    };

    applyStyle(style) {
      this.dataset.activeStyle = style;

      for (const button of this.querySelectorAll('[data-organza-style]')) {
        if (!(button instanceof HTMLButtonElement)) continue;
        const active = button.dataset.organzaStyle === style;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }

      for (const color of this.querySelectorAll('[data-organza-color-style]')) {
        if (!(color instanceof HTMLElement)) continue;
        color.hidden = style !== 'ALL' && color.dataset.organzaColorStyle !== style;
      }
    }
  }

  if (!customElements.get('nkc-organza-selector')) {
    customElements.define('nkc-organza-selector', NkcOrganzaSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
